// extracted by mini-css-extract-plugin
export var cell = "_6v-4";
export var headerCell = "_6v-2";
export var rowHeader = "_6v-3";
export var table = "_6v-1";
export var tableContainer = "_6v-0";